export const getLocalToken = () => {
  return localStorage.getItem("token");
};

